import { gql } from "@apollo/client";

export const AUTORIZAR_CONEXIONES = gql`
    mutation autorizarConexiones($conexiones: [AutorizarInput!]!) {
    autorizarConexiones(conexiones: $conexiones) {
      success,
      error,
      valorEsperado
    }
  }
`;